/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiTextMatchingMode} from "./UiTextMatchingMode";


export interface UiTreeConfig extends UiComponentConfig {
	_type?: string;
	treeData: any[];
	templates: {[name: string]: UiTemplateConfig};
	defaultTreeTemplateNames?: string[];
	templateProperty?: string;
	idPropertyName: string;
	parentIdPropertyName: string;
	expandedProperty?: string;
	lazyChildrenFlagProperty?: string;
	animate?: boolean;
	showExpanders?: boolean;
	openOnSelection?: boolean;
	enforceSingleExpandedPath?: boolean;
	indentation?: number;
	matchFieldNames?: string[];
	textMatchingMode?: UiTextMatchingMode
}

export interface UiTreeCommandHandler {
	setData(treeData: any[]): void;
	setChildren(parentId: any, children: any[]): void;
	addOrUpdateNode(node: any): void;
	relocateNode(recordId: any, newParentRecordId: any): void;
	removeNode(recordId: any): void;
	removeAllNodes(): void;
	selectNode(recordId: any): void;
}

export interface UiTreeEventSource {
	onNodeSelected: TeamAppsEvent<UiTree_NodeSelectedEvent>;
	onRequestTreeData: TeamAppsEvent<UiTree_RequestTreeDataEvent>;
}

export interface UiTree_NodeSelectedEvent extends UiEvent {
	_type: "UiTree.nodeSelected";
	redundancyKey?: string;
	node: any
}

export interface UiTree_RequestTreeDataEvent extends UiEvent {
	_type: "UiTree.requestTreeData";
	redundancyKey?: string;
	parentNodeId: any
}

